import httpClient from '../httpClient'
import JsonApiSerializer from '../JsonApiSerializer'
import AdminService from './AdminService'
import AgentService from './AgentService'
import AgentPostCalendarService from './AgentPostCalendarService'
import MeetingPointService from './MeetingPointService'
import PostCalendarService from './PostCalendarService'
import PostImageService from './PostImageService'
import PostPriceService from './PostPriceService'
import PostService from './PostService'
import PostStartTimeService from './PostStartTimeService'
import PostVideoService from './PostVideoService'
import DirectReservationService from './DirectReservationService'
import ReservationService from './ReservationService'
import OtaReservationService from './OtaReservationService'
import OtaPendingReservationService from './OtaPendingReservationService'
import DmcTourService from './DmcTourService'
import GuideReportService from './GuideReportService'
import TroubleReportService from './TroubleReportService'
import RemindMailTemplateService from './RemindMailTemplateService'
import SettingsService from './SettingsService'
import ThanksMailService from './ThanksMailService'
import UserService from './UserService'
import UtilService from './UtilService'
import TourService from './ToursService'
import ReviewService from './ReviewService'
import PaymentDetailService from './PaymentDetailService'
import JobService from './JobService'

const jsonApiSerializer = new JsonApiSerializer()

export const postService = new PostService(httpClient, jsonApiSerializer)
export const postPriceService = new PostPriceService(httpClient, jsonApiSerializer)
export const postVideoService = new PostVideoService(httpClient, jsonApiSerializer)
export const postCalendarService = new PostCalendarService(httpClient, jsonApiSerializer)
export const agentPostCalendarService = new AgentPostCalendarService(httpClient, jsonApiSerializer)
export const postImageService = new PostImageService(httpClient, jsonApiSerializer)
export const postStartTimeService = new PostStartTimeService(httpClient, jsonApiSerializer)
export const adminService = new AdminService(httpClient, jsonApiSerializer)
export const agentService = new AgentService(httpClient, jsonApiSerializer)
export const userService = new UserService(httpClient, jsonApiSerializer)
export const directReservationService = new DirectReservationService(httpClient, jsonApiSerializer)
export const reservationService = new ReservationService(httpClient, jsonApiSerializer)
export const otaReservationService = new OtaReservationService(httpClient, jsonApiSerializer)
export const otaPendingReservationService = new OtaPendingReservationService(
  httpClient,
  jsonApiSerializer
)
export const dmcTourService = new DmcTourService(httpClient, jsonApiSerializer)
export const guideReportService = new GuideReportService(httpClient, jsonApiSerializer)
export const troubleReportService = new TroubleReportService(httpClient, jsonApiSerializer)
export const remindMailTemplateService = new RemindMailTemplateService(
  httpClient,
  jsonApiSerializer
)
export const settingsService = new SettingsService(httpClient, jsonApiSerializer)
export const meetingPointService = new MeetingPointService(httpClient, jsonApiSerializer)
export const utilService = new UtilService(httpClient, jsonApiSerializer)
export const thanksMailService = new ThanksMailService(httpClient, jsonApiSerializer)
export const tourService = new TourService(httpClient, jsonApiSerializer)
export const reviewService = new ReviewService(httpClient, jsonApiSerializer)
export const paymentDetailService = new PaymentDetailService(httpClient, jsonApiSerializer)
export const jobService = new JobService(httpClient, jsonApiSerializer)
